export class RegionFeatureStatus {

  static FORCED        = new RegionFeatureStatus('FORCED', true, true);
  static AVAILABLE     = new RegionFeatureStatus('AVAILABLE', true, false);
  static NOT_AVAILABLE = new RegionFeatureStatus('NOT_AVAILABLE', false, false);

  private constructor(public label: string, public available: boolean, public forced: boolean) {
  }

  static fromName(name: string): RegionFeatureStatus {
    return this.values().find(f => f.label === name);
  }

  static values(): RegionFeatureStatus[] {
    return Object.getOwnPropertyNames(this)
      .map(p => Object.getOwnPropertyDescriptor(this, p))
      .filter(p => p.enumerable)
      .filter(p => p.value instanceof RegionFeatureStatus)
      .map(p => p.value);
  }

}
